import { render, staticRenderFns } from "./ActionDocument.vue?vue&type=template&id=bad7975a&"
import script from "./ActionDocument.vue?vue&type=script&lang=js&"
export * from "./ActionDocument.vue?vue&type=script&lang=js&"
import style0 from "./ActionDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports